.row {
  cursor: pointer;
}

.initials {
  display: inline-block;
  margin-right: var(--space-s);
}
